export const usStates = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];

export const canadaProvinces = [
  "AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"
];

export const countryList: { code: string; name: string }[] = [
  { code: "US", name: "United States (US)" },
  { code: "CA", name: "Canada (CAN)" },
  { code: "AF", name: "Afghanistan (AF)" },
  { code: "AX", name: "Åland Islands (AX)" },
  { code: "AL", name: "Albania (AL)" },
  { code: "DZ", name: "Algeria (DZ)" },
  { code: "AS", name: "American Samoa (AS)" },
  { code: "AD", name: "Andorra (AD)" },
  { code: "AO", name: "Angola (AO)" },
  { code: "AI", name: "Anguilla (AI)" },
  { code: "AQ", name: "Antarctica (AQ)" },
  { code: "AG", name: "Antigua and Barbuda (AG)" },
  { code: "AR", name: "Argentina (AR)" },
  { code: "AM", name: "Armenia (AM)" },
  { code: "AW", name: "Aruba (AW)" },
  { code: "AU", name: "Australia (AU)" },
  { code: "AT", name: "Austria (AT)" },
  { code: "AZ", name: "Azerbaijan (AZ)" },
  { code: "BS", name: "Bahamas (BS)" },
  { code: "BH", name: "Bahrain (BH)" },
  { code: "BD", name: "Bangladesh (BD)" },
  { code: "BB", name: "Barbados (BB)" },
  { code: "BY", name: "Belarus (BY)" },
  { code: "BE", name: "Belgium (BE)" },
  { code: "BZ", name: "Belize (BZ)" },
  { code: "BJ", name: "Benin (BJ)" },
  { code: "BM", name: "Bermuda (BM)" },
  { code: "BT", name: "Bhutan (BT)" },
  { code: "BO", name: "Bolivia (BO)" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba (BQ)" },
  { code: "BA", name: "Bosnia and Herzegovina (BA)" },
  { code: "BW", name: "Botswana (BW)" },
  { code: "BV", name: "Bouvet Island (BV)" },
  { code: "BR", name: "Brazil (BR)" },
  { code: "IO", name: "British Indian Ocean Territory (IO)" },
  { code: "BN", name: "Brunei Darussalam (BN)" },
  { code: "BG", name: "Bulgaria (BG)" },
  { code: "BF", name: "Burkina Faso (BF)" },
  { code: "BI", name: "Burundi (BI)" },
  { code: "CV", name: "Cabo Verde (CV)" },
  { code: "KH", name: "Cambodia (KH)" },
  { code: "CM", name: "Cameroon (CM)" },
  { code: "KY", name: "Cayman Islands (KY)" },
  { code: "CF", name: "Central African Republic (CF)" },
  { code: "TD", name: "Chad (TD)" },
  { code: "CL", name: "Chile (CL)" },
  { code: "CN", name: "China (CN)" },
  { code: "CX", name: "Christmas Island (CX)" },
  { code: "CC", name: "Cocos (Keeling) Islands (CC)" },
  { code: "CO", name: "Colombia (CO)" },
  { code: "KM", name: "Comoros (KM)" },
  { code: "CG", name: "Congo (CG)" },
  { code: "CD", name: "Congo, Democratic Republic of the (CD)" },
  { code: "CK", name: "Cook Islands (CK)" },
  { code: "CR", name: "Costa Rica (CR)" },
  { code: "CI", name: "Côte d'Ivoire (CI)" },
  { code: "HR", name: "Croatia (HR)" },
  { code: "CU", name: "Cuba (CU)" },
  { code: "CW", name: "Curaçao (CW)" },
  { code: "CY", name: "Cyprus (CY)" },
  { code: "CZ", name: "Czechia (CZ)" },
  { code: "DK", name: "Denmark (DK)" },
  { code: "DJ", name: "Djibouti (DJ)" },
  { code: "DM", name: "Dominica (DM)" },
  { code: "DO", name: "Dominican Republic (DO)" },
  { code: "EC", name: "Ecuador (EC)" },
  { code: "EG", name: "Egypt (EG)" },
  { code: "SV", name: "El Salvador (SV)" },
  { code: "GQ", name: "Equatorial Guinea (GQ)" },
  { code: "ER", name: "Eritrea (ER)" },
  { code: "EE", name: "Estonia (EE)" },
  { code: "SZ", name: "Eswatini (SZ)" },
  { code: "ET", name: "Ethiopia (ET)" },
  { code: "FK", name: "Falkland Islands (Malvinas) (FK)" },
  { code: "FO", name: "Faroe Islands (FO)" },
  { code: "FJ", name: "Fiji (FJ)" },
  { code: "FI", name: "Finland (FI)" },
  { code: "FR", name: "France (FR)" },
  { code: "GF", name: "French Guiana (GF)" },
  { code: "PF", name: "French Polynesia (PF)" },
  { code: "TF", name: "French Southern Territories (TF)" },
  { code: "GA", name: "Gabon (GA)" },
  { code: "GM", name: "Gambia (GM)" },
  { code: "GE", name: "Georgia (GE)" },
  { code: "DE", name: "Germany (DE)" },
  { code: "GH", name: "Ghana (GH)" },
  { code: "GI", name: "Gibraltar (GI)" },
  { code: "GR", name: "Greece (GR)" },
  { code: "GL", name: "Greenland (GL)" },
  { code: "GD", name: "Grenada (GD)" },
  { code: "GP", name: "Guadeloupe (GP)" },
  { code: "GU", name: "Guam (GU)" },
  { code: "GT", name: "Guatemala (GT)" },
  { code: "GG", name: "Guernsey (GG)" },
  { code: "GN", name: "Guinea (GN)" },
  { code: "GW", name: "Guinea-Bissau (GW)" },
  { code: "GY", name: "Guyana (GY)" },
  { code: "HT", name: "Haiti (HT)" },
  { code: "HM", name: "Heard Island and McDonald Islands (HM)" },
  { code: "VA", name: "Holy See (VA)" },
  { code: "HN", name: "Honduras (HN)" },
  { code: "HK", name: "Hong Kong (HK)" },
  { code: "HU", name: "Hungary (HU)" },
  { code: "IS", name: "Iceland (IS)" },
  { code: "IN", name: "India (IN)" },
  { code: "ID", name: "Indonesia (ID)" },
  { code: "IR", name: "Iran (IR)" },
  { code: "IQ", name: "Iraq (IQ)" },
  { code: "IE", name: "Ireland (IE)" },
  { code: "IM", name: "Isle of Man (IM)" },
  { code: "IL", name: "Israel (IL)" },
  { code: "IT", name: "Italy (IT)" },
  { code: "JM", name: "Jamaica (JM)" },
  { code: "JP", name: "Japan (JP)" },
  { code: "JE", name: "Jersey (JE)" },
  { code: "JO", name: "Jordan (JO)" },
  { code: "KZ", name: "Kazakhstan (KZ)" },
  { code: "KE", name: "Kenya (KE)" },
  { code: "KI", name: "Kiribati (KI)" },
  { code: "KP", name: "Korea, Democratic People's Republic of (KP)" },
  { code: "KR", name: "Korea, Republic of (KR)" },
  { code: "KW", name: "Kuwait (KW)" },
  { code: "KG", name: "Kyrgyzstan (KG)" },
  { code: "LA", name: "Lao People's Democratic Republic (LA)" },
  { code: "LV", name: "Latvia (LV)" },
  { code: "LB", name: "Lebanon (LB)" },
  { code: "LS", name: "Lesotho (LS)" },
  { code: "LR", name: "Liberia (LR)" },
  { code: "LY", name: "Libya (LY)" },
  { code: "LI", name: "Liechtenstein (LI)" },
  { code: "LT", name: "Lithuania (LT)" },
  { code: "LU", name: "Luxembourg (LU)" },
  { code: "MO", name: "Macao (MO)" },
  { code: "MG", name: "Madagascar (MG)" },
  { code: "MW", name: "Malawi (MW)" },
  { code: "MY", name: "Malaysia (MY)" },
  { code: "MV", name: "Maldives (MV)" },
  { code: "ML", name: "Mali (ML)" },
  { code: "MT", name: "Malta (MT)" },
  { code: "MH", name: "Marshall Islands (MH)" },
  { code: "MQ", name: "Martinique (MQ)" },
  { code: "MR", name: "Mauritania (MR)" },
  { code: "MU", name: "Mauritius (MU)" },
  { code: "YT", name: "Mayotte (YT)" },
  { code: "MX", name: "Mexico (MX)" },
  { code: "FM", name: "Micronesia (FM)" },
  { code: "MD", name: "Moldova (MD)" },
  { code: "MC", name: "Monaco (MC)" },
  { code: "MN", name: "Mongolia (MN)" },
  { code: "ME", name: "Montenegro (ME)" },
  { code: "MS", name: "Montserrat (MS)" },
  { code: "MA", name: "Morocco (MA)" },
  { code: "MZ", name: "Mozambique (MZ)" },
  { code: "MM", name: "Myanmar (MM)" },
  { code: "NA", name: "Namibia (NA)" },
  { code: "NR", name: "Nauru (NR)" },
  { code: "NP", name: "Nepal (NP)" },
  { code: "NL", name: "Netherlands (NL)" },
  { code: "NC", name: "New Caledonia (NC)" },
  { code: "NZ", name: "New Zealand (NZ)" },
  { code: "NI", name: "Nicaragua (NI)" },
  { code: "NE", name: "Niger (NE)" },
  { code: "NG", name: "Nigeria (NG)" },
  { code: "NU", name: "Niue (NU)" },
  { code: "NF", name: "Norfolk Island (NF)" },
  { code: "MK", name: "North Macedonia (MK)" },
  { code: "MP", name: "Northern Mariana Islands (MP)" },
  { code: "NO", name: "Norway (NO)" },
  { code: "OM", name: "Oman (OM)" },
  { code: "PK", name: "Pakistan (PK)" },
  { code: "PW", name: "Palau (PW)" },
  { code: "PS", name: "Palestine, State of (PS)" },
  { code: "PA", name: "Panama (PA)" },
  { code: "PG", name: "Papua New Guinea (PG)" },
  { code: "PY", name: "Paraguay (PY)" },
  { code: "PE", name: "Peru (PE)" },
  { code: "PH", name: "Philippines (PH)" },
  { code: "PN", name: "Pitcairn (PN)" },
  { code: "PL", name: "Poland (PL)" },
  { code: "PT", name: "Portugal (PT)" },
  { code: "PR", name: "Puerto Rico (PR)" },
  { code: "QA", name: "Qatar (QA)" },
  { code: "RE", name: "Réunion (RE)" },
  { code: "RO", name: "Romania (RO)" },
  { code: "RU", name: "Russian Federation (RU)" },
  { code: "RW", name: "Rwanda (RW)" },
  { code: "BL", name: "Saint Barthélemy (BL)" },
  { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha (SH)" },
  { code: "KN", name: "Saint Kitts and Nevis (KN)" },
  { code: "LC", name: "Saint Lucia (LC)" },
  { code: "MF", name: "Saint Martin (French part) (MF)" },
  { code: "PM", name: "Saint Pierre and Miquelon (PM)" },
  { code: "VC", name: "Saint Vincent and the Grenadines (VC)" },
  { code: "WS", name: "Samoa (WS)" },
  { code: "SM", name: "San Marino (SM)" },
  { code: "ST", name: "Sao Tome and Principe (ST)" },
  { code: "SA", name: "Saudi Arabia (SA)" },
  { code: "SN", name: "Senegal (SN)" },
  { code: "RS", name: "Serbia (RS)" },
  { code: "SC", name: "Seychelles (SC)" },
  { code: "SL", name: "Sierra Leone (SL)" },
  { code: "SG", name: "Singapore (SG)" },
  { code: "SX", name: "Sint Maarten (Dutch part) (SX)" },
  { code: "SK", name: "Slovakia (SK)" },
  { code: "SI", name: "Slovenia (SI)" },
  { code: "SB", name: "Solomon Islands (SB)" },
  { code: "SO", name: "Somalia (SO)" },
  { code: "ZA", name: "South Africa (ZA)" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands (GS)" },
  { code: "SS", name: "South Sudan (SS)" },
  { code: "ES", name: "Spain (ES)" },
  { code: "LK", name: "Sri Lanka (LK)" },
  { code: "SD", name: "Sudan (SD)" },
  { code: "SR", name: "Suriname (SR)" },
  { code: "SJ", name: "Svalbard and Jan Mayen (SJ)" },
  { code: "SE", name: "Sweden (SE)" },
  { code: "CH", name: "Switzerland (CH)" },
  { code: "SY", name: "Syrian Arab Republic (SY)" },
  { code: "TW", name: "Taiwan (TW)" },
  { code: "TJ", name: "Tajikistan (TJ)" },
  { code: "TZ", name: "Tanzania (TZ)" },
  { code: "TH", name: "Thailand (TH)" },
  { code: "TL", name: "Timor-Leste (TL)" },
  { code: "TG", name: "Togo (TG)" },
  { code: "TK", name: "Tokelau (TK)" },
  { code: "TO", name: "Tonga (TO)" },
  { code: "TT", name: "Trinidad and Tobago (TT)" },
  { code: "TN", name: "Tunisia (TN)" },
  { code: "TR", name: "Turkey (TR)" },
  { code: "TM", name: "Turkmenistan (TM)" },
  { code: "TC", name: "Turks and Caicos Islands (TC)" },
  { code: "TV", name: "Tuvalu (TV)" },
  { code: "UG", name: "Uganda (UG)" },
  { code: "UA", name: "Ukraine (UA)" },
  { code: "AE", name: "United Arab Emirates (AE)" },
  { code: "GB", name: "United Kingdom (GB)" },
  { code: "UM", name: "United States Minor Outlying Islands (UM)" },
  { code: "UY", name: "Uruguay (UY)" },
  { code: "UZ", name: "Uzbekistan (UZ)" },
  { code: "VU", name: "Vanuatu (VU)" },
  { code: "VE", name: "Venezuela (VE)" },
  { code: "VN", name: "Viet Nam (VN)" },
  { code: "VG", name: "Virgin Islands, British (VG)" },
  { code: "VI", name: "Virgin Islands, U.S. (VI)" },
  { code: "WF", name: "Wallis and Futuna (WF)" },
  { code: "EH", name: "Western Sahara (EH)" },
  { code: "YE", name: "Yemen (YE)" },
  { code: "ZM", name: "Zambia (ZM)" },
  { code: "ZW", name: "Zimbabwe (ZW)" },
];

export const getStateProvinceOptions = (countryCode: string): string[] => {
  if (countryCode === "US") {
    return usStates;
  } else if (countryCode === "CA") {
    return canadaProvinces;
  }
  return [];
};
